import { type Registry as Services } from '@ember/service';
import type { ModelRegistry } from 'ember-data/types/registries/model';

// The account owner has no `Teammate` row of their own, so `GET /teammates` never lists them —
// but `Task::Assign` on the backend already accepts the owner's own user id as a valid assignee.
// This synthesizes a local-only entry for the picker; it's never pushed into the store, so it
// can't leak into any other teammate list in the app.
export function withSelf(
  teammates: ModelRegistry['teammate'][],
  currentUser: ModelRegistry['user'] | undefined,
  intl: Services['intl'],
): ModelRegistry['teammate'][] {
  if (
    !currentUser ||
    teammates.some((teammate) => teammate.userId === currentUser.id)
  ) {
    return teammates;
  }

  const self = {
    id: `self-${currentUser.id}`,
    userId: currentUser.id,
    name: intl.t('action.tasks.assignee_you', { name: currentUser.name }),
  } as ModelRegistry['teammate'];

  return [self, ...teammates];
}
